import { BodyFormModel } from './BodyFormModel';
import { ref, reactive } from 'vue';
import { BodyRelatedData } from './BodyRelatedData';
import { IFormOperations } from './IFormOperations';
import { FormTab } from './FormTab';
import { FormInstance, FormRules } from 'element-plus';
import { BodyFormRules } from './BodyFormRules';

export class BodyFormCB implements IFormOperations {
	public readonly tab = FormTab.BASIC_INFORMATION;

	public formRef = ref<FormInstance>();
	public rules = reactive<FormRules>(BodyFormRules);
	public formModel = ref<BodyFormModel>();
	public relatedData = reactive(new BodyRelatedData());

	public constructor(formModel: BodyFormModel | undefined) {
		this.formModel.value = formModel;
	}

	public async validate(): Promise<boolean> {
		try {
			await this.formRef.value?.validate();
			return true;
		} catch (e) {
			return false;
		}
	}
}
